export default __webpack_public_path__ + "static/media/analytics.d42a505f.svg";